import { useState } from "react";
import type { ComponentType } from "react";
import { navigation, viewFromLocation } from "./data";
import { OpsContext, useOps } from "./hooks/useOps";
import { Shell } from "./components/Shell";
import type { ViewId } from "./types";
import { ControlView, LiveView, SalesView, ClientsView, LunchboxView, StaffView, ForecastView, MenuView, SystemView } from "./views/OperationalViews";
import { SettlementView } from "./views/SettlementView";

const viewComponents: Record<ViewId, ComponentType> = {
  control: ControlView,
  live: LiveView,
  sales: SalesView,
  clients: ClientsView,
  lunchbox: LunchboxView,
  staff: StaffView,
  forecast: ForecastView,
  menu: MenuView,
  settlement: SettlementView,
  system: SystemView,
};

export default function App() {
  const [view, setView] = useState<ViewId>(viewFromLocation);
  const { snapshot, loading, refresh } = useOps();
  const View = viewComponents[view];

  const navigate = (next: ViewId) => {
    setView(next);
    const url = new URL(window.location.href);
    url.searchParams.set("view", next);
    window.history.pushState({}, "", url);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Shell view={view} snapshot={snapshot} loading={loading} onNavigate={navigate} onRefresh={refresh}>
      <OpsContext.Provider value={snapshot}>
        <View />
      </OpsContext.Provider>
      <p className="build-footnote">
        {navigation.find((item) => item.id === view)?.label} · 실제 원천이 연결되기 전에는 수치를 표시하지 않습니다.
      </p>
    </Shell>
  );
}
